import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { calculateEnablementCountryColors } from '@/features/enablementMap/calculateCountryColors'
import { tableColumns } from '@/features/enablementMap/columns'
import { exportFields } from '@/features/enablementMap/exportFields'
// import type { DemandMapDeployment } from '@/features/demand/models/demandSchema'
import {
	createInitialEnablementFilterGroups,
	enablementMapDeploymentsQueryOptions,
} from '@/features/enablementMap/initialiseEnablementData'
import type { EnablementMapDeployment } from '@/features/enablementMap/models/enablementSchema'
import FilteredMap from '@/features/filteredMap/index'

export const Route = createFileRoute('/enablement')({
	loader: ({ context }) =>
		context.queryClient.ensureQueryData(
			enablementMapDeploymentsQueryOptions
		),
	component: RouteComponent,
	head: () => ({
		meta: [
			{
				title: 'Enablement',
			},
		],
	}),
})

declare module 'react' {
	interface CSSProperties {
		'--grid-template-columns-details-grid'?: string
	}
}
function RouteComponent() {
	const { isLoading, data } = useSuspenseQuery(
		enablementMapDeploymentsQueryOptions
	)
	const { filterGroups, initialData } = createInitialEnablementFilterGroups(
		data.deployments
	)

	if (isLoading) return <div>Loading...</div>
	return (
		<div
			className=""
			style={{
				'--grid-template-columns-details-grid':
					'minmax(0, 1fr) repeat(4, minmax(0, 0.6fr))  minmax(0, 0.8fr)',
			}}
		>
			<FilteredMap<EnablementMapDeployment>
				filterGroups={filterGroups}
				initialData={initialData}
				themeColor="orange"
				mapTitle="Channel Partner Readiness"
				calculateCountriesColorMappingFn={
					calculateEnablementCountryColors
				}
				tableColumns={tableColumns}
				exportFields={exportFields}
				drawerTitle="Channel Partner Readiness"
			/>
		</div>
	)
}
